export default {
    key: "municipal_interventions",
    folder: "municipalInterventions",
    basePath: "municipalinterventions",
    acl: 'GIM_14000',
};